import { IDanhSachDangKyNganh2UpdateDuyetRequest } from "../../../model/request/quan-ly-nganh-2/IDanhSachDangKyNganh2UpdateDuyetRequest";
import { IDanhSachDangKyNganh2 } from "../../../model/response/quan-ly-nganh-2/IDanhSachDangKyNganh2";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhSachDangKyNganh2ActionsObj = {
    LOAD_BY_DOT_START: 0,
    LOAD_BY_DOT_SUCCESS: {} as IDanhSachDangKyNganh2[],
    LOAD_BY_DOT_ERROR: "",

    DUYETS_START: {} as IDanhSachDangKyNganh2UpdateDuyetRequest,
    DUYETS_SUCCESS: undefined,
    DUYETS_ERROR: "",

}

export const eDanhSachDangKyNganh2ActionIds = generateActionTypeIds(eDanhSachDangKyNganh2ActionsObj,"DANH_SACH_DANG_KY_NGANH_2");
export type IDanhSachDangKyNganh2ActionTypes = IGenericActionType<typeof eDanhSachDangKyNganh2ActionsObj, "DANH_SACH_DANG_KY_NGANH_2">;